<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Short Stories</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li>
<li id="toc-li-5"><a href="#/text/ch005#a-monkeys-divorce">A Monkey’s Divorce</a></li>
<li id="toc-li-6"><span href="#/text/ch006#ghost-story" title="Link target outside of Sample">Ghost Story</span></li>
<li id="toc-li-7"><span href="#/text/ch007#the-sand-bar" title="Link target outside of Sample">The Sand Bar</span></li>
<li id="toc-li-10"><span href="#/text/ch010#an-exile" title="Link target outside of Sample">An Exile</span></li>
<li id="toc-li-11"><span href="#/text/ch011#a-fair-exchange" title="Link target outside of Sample">A Fair Exchange</span></li>
<li id="toc-li-12"><span href="#/text/ch012#a-friend-of-the-family" title="Link target outside of Sample">A Friend of the Family</span></li>
<li id="toc-li-13"><span href="#/text/ch013#in-tuscany" title="Link target outside of Sample">In Tuscany</span></li>
<li id="toc-li-14"><span href="#/text/ch014#in-the-quicksand-of-nostalgia" title="Link target outside of Sample">In the Quicksand of Nostalgia</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?3cd71eb4